import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AnchorResult, BoundingBoxAnchorResult } from "@shared/models/common";
import { OnInit } from "@angular/core";

@Component({
    selector: 'create-bounding-box-anchor-form',
    templateUrl: './create-bounding-box-anchor-form.component.html',
    styleUrls: ['./create-bounding-box-anchor-form.component.scss'],
    standalone: false
})
export class CreateBoundingBoxAnchorFormComponent implements OnInit {


    @Input() anchorToCreate: BoundingBoxAnchorResult;

    @Input() existingAnchors: AnchorResult[] = [];

    @Output() createBoundingBoxAnchor = new EventEmitter<void>();
    
    @Output() onClose = new EventEmitter<void>();

    isAlreadyAddedAnchor: boolean = false;
    ngOnInit(): void {
        
        this.isAlreadyAddedAnchor = this.anchorToCreate.refDocAnchorId != null && this.existingAnchors?.some(anchor => anchor.refDocAnchorId === this.anchorToCreate.refDocAnchorId) === true;
    }

    save() {

        this.createBoundingBoxAnchor.emit();
    }

    close() {

        this.onClose.emit();
    }



}
